{
  "eyebrow": "Bekreft abonnementet",
  "title": "Se gjennom og konfigurer.",
  "sub": "Du kan endre faktureringssyklus eller abonnement når som helst fra administratorpanelet.",
  "yourPlan": "Ditt abonnement",
  "changePlan": "Endre abonnement",
  "billing": "Faktureringssyklus",
  "billingMonthLabel": "Betal månedlig",
  "billingMonthDesc": "Fleksibelt. Avslutt når som helst.",
  "billingYearLabel": "Betal årlig",
  "billingYearDesc": "15% rabatt. Faktureres én gang i året.",
  "addons": "Tillegg",
  "addon": {
    "ssec": "Trygd (check-in/out@work)",
    "ssecDesc": "Bare Belgia — automatisk Dimona-melding.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live-GPS for firmakjøretøy. +4 €/kjøretøy/måned.",
    "vehicles": "Kjøretøy"
  },
  "employees": {
    "title": "Hvor mange ansatte?",
    "active": "brukere",
    "popular": "De fleste team velger {{n}}"
  },
  "estimate": "Estimerte månedlige kostnader",
  "estimateNote": "Eks. mva. Du betaler for antallet brukere du angir her, og kan endre det senere.",
  "estimateUnavailable": "Priskatalog ikke tilgjengelig. Prøv igjen for å laste de nyeste prisene."
}
